/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from "react";
import { Row, Card, CardBody, Col } from "reactstrap";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import DeclinedCalendarIcon from "../../../images/CalendarDeclined.svg";
import logo from "../../../images/Logo_nFiniti_black.svg";
import checkIcon from "../../../images/SubmitCheckIcon.svg";
import CalendarIcon from "../../../images/calendar.svg";
import {
  GetResponseCategoreis,
  OverallPercentage,
} from "../../../models/ClientportalDashboardModels/GetResponseCategoreis";
import "./Dashboard.scss";
import Service from "../../../services";
import { catchError } from "../../../utils/Utils";
import { signStatusObject } from "../../../models/ClientportalDashboardModels/GetResponseCategoreis";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import FileViewer from "react-file-viewer";
import FinSpinner from "../../../commonfields/FinSpinner";
import { AxiosError, AxiosResponse } from "axios";
import checkBlue from "../../../images/checkBlue.svg";
import { useParams } from "react-router";
import { CLIENT_SCREEN_TYPES } from "../../../utils/RoutesUtil";

interface DashboardStatsFCProps {
  qustionaryData?: GetResponseCategoreis;
  percentageData: OverallPercentage;
  submittedStatusData?: boolean;
  clientId: string | undefined;
  signStatusObject?: any;
  setIframeForDocuSign?: (url: any) => void;
  applicationStatusData?: any;
  clientProductId: string|undefined;
}

const DashboardStatsFC = (props: DashboardStatsFCProps) => {
  const service = new Service();
  const [viewFile, setViewFile] = useState(false);
  const [loader, setloader] = useState(false);
  const [downloadFile, setDownloadFile] = useState<any>();
  const {screenType} = useParams();

  const DownloadFile = () => {
    // service
    // .getChecklistReport(props.clientId)
    // .then((response: any) => {
    //   const blob = new Blob([response.data], { type: "application/octet-stream" })
    //   const link = document.createElement('a')
    //   link.href = window.URL.createObjectURL(blob)
    //   link.download = 'AccountOpeningChecklist.xlsx';
    //    link.click()
    // })
    // .catch((error: any) => {
    //   console.log(error);
    //   catchError(error,true)
    // });
  };

  const docuSignSet = (url: any) => {
    // setDisbaleViewAndSign(true);
    props?.setIframeForDocuSign && props.setIframeForDocuSign(url);
  };

  const downloadDocuSign = () => {
    setloader(true);
    props.clientId &&
      service
        .downloadDocuSignReport("underwritter", props.clientId)
        .then((res: AxiosResponse<any>) => {
          setloader(false);
          setDownloadFile(res.data);
          setViewFile(true);
        })
        .catch((error: AxiosError) => {
          setloader(false);
          catchError(error, true);
        });
  };

  const getDocuSignStatusDetails = () => {
    if (props.percentageData?.status === "COMPLIANCE_SIGNING_INPROGRESS") {
      return (
        <div className="submittedDiv">
          <div className="imageDiv">
            <img className="submittedImg" src={logo} alt="sidebar" />
          </div>

          {props?.signStatusObject?.find(
            (m: signStatusObject) => m?.signerDocusignUrl !== null
          ) ? (
            <div>
              <p className="signedHeading mb-3">Application Not Signed</p>
              <p className="submittedText">
                You have not signed your account application
                <br />
              </p>
            </div>
          ) : (
            <div>
              <p className="signedHeading">
                {" "}
                <img
                  src={checkBlue}
                  className="checkBlue"
                  alt="contactImg"
                />{" "}
                Application Signed
              </p>
              <p className="submittedText">
                You have successfully signed your account application on
                {props?.applicationStatusData?.applicationDate}. <br />
              </p>
            </div>
          )}
          <p className="submittedHeading">Signatures Required:</p>
          <div className="namesContainer">
            {props?.signStatusObject.map((m: signStatusObject, index: any) => {
              return (
                <div className="singleNameContainer" key={index}>
                  <div className="signerNameDiv">
                    {" "}
                    <p className="signerName">{m.signerName}</p>
                  </div>
                  <div>
                    {m.signingStatus == "completed" && (
                      <img src={checkIcon} alt="approvedImg" />
                    )}
                    {m.signerDocusignUrl && (
                      <p
                        onClick={() => docuSignSet(m.signerDocusignUrl)}
                        className="viewAndSign"
                      >
                        View and Sign
                      </p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <p className="closeWindowText">
            We will contact you if additional information is needed. You can
            view your completed application here:
            <span className="application_link" onClick={downloadDocuSign}>
              {props.applicationStatusData?.company}_application_details
            </span>{" "}
            <br />
            You can now close out this window.
          </p>
        </div>
      );
    } else if (props.percentageData?.status === "REVIEW_COMPLETED") {
      return (
        <div className="submittedDiv">
          <div className="imageDiv">
            <img className="submittedImg" src={logo} alt="sidebar" />
          </div>
          <p className="submittedHeadingText">
            {" "}
            <img src={checkIcon} alt="contactImg"></img> Application Submitted{" "}
          </p>
          <p className="submittedText">
            Congratulations! successfully submitted merchant account application
            on {props.percentageData?.statusChangedDate}.
            <br />
          </p>
          <br />
          <p className="closeWindowText">
            You can view completed application here:
            <span
              className="application_link"
              onClick={() => downloadDocuSign()}
            >
              {props.applicationStatusData?.company}_application_details
            </span>{" "}
            <br />
          </p>
        </div>
      );
    } else return <></>;
  };

  return (
    <Row className="progressWrapper">
      <Col sm="12" className="statsCard">
        <Card className="dasboardCard">
         {screenType?.toLowerCase()===CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW && <CardBody className="p-0">
            {props.percentageData?.status !== "Review Completed" &&
            props.percentageData?.status !== "REVIEW_DECLINED" ? (
              <Row>
                <Col className="overallDiv">
                  <div
                    style={{ width: 105, height: 105 }}
                    className="overallPercentage"
                  >
                    <CircularProgressbar
                      strokeWidth={14}
                      value={
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }
                      text={`${
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }%`}
                      styles={buildStyles({
                        textSize: "24px",

                        pathTransitionDuration: 2.0,

                        pathColor: `rgba(0,0,0,0.2, ${
                          props.percentageData?.overallPercentage / 100
                        })`,

                        textColor: "#0C2240",

                        trailColor: "rgb(235 235 235)",

                        backgroundColor: "#0C2240",
                      })}
                    />
                  </div>

                  <span className="competionText">
                    Review <br /> Completion
                  </span>
                </Col>

               <Col>
                  <img
                    src={CalendarIcon}
                    alt="CalendarIcon"
                    className="messageIcon"
                  />

                  <span className="unreadNumber">
                    {props.percentageData?.daysInReview}
                  </span>

                  <span className="unreadText">
                    {props.percentageData?.daysInReview == 1 ? "Day" : "Days"}{" "}
                    in <br /> Review
                  </span>
                </Col>
              </Row>
            ) : (
              ""
            )}
            {props.percentageData?.status === "Review Completed" && (
              <Row className="reviewCompltedContainer">
                <Col className="percentage-container" md={6}>
                  <div
                    style={{ width: 105, height: 105 }}
                    className="overallPercentage"
                  >
                    <CircularProgressbar
                      strokeWidth={14}
                      value={
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }
                      text={`${
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }%`}
                      styles={buildStyles({
                        // Rotation of path and trail, in number of turns (0-1)
                        // rotation: 0.25,

                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                        // strokeLinecap: "butt",

                        // Text size
                        textSize: "24px",

                        // How long animation takes to go from one percentage to another, in seconds
                        pathTransitionDuration: 2.0,

                        // Can specify path transition in more detail, or remove it entirely
                        // pathTransition: 'none',

                        // Colors
                        pathColor: `rgba(0,0,0,0.2, ${
                          props.percentageData?.overallPercentage / 100
                        })`,
                        textColor: "#0C2240",
                        trailColor: "rgb(235 235 235)",
                        backgroundColor: "#0C2240",
                      })}
                    />
                  </div>
                  <span className="competionText">
                    Review <br /> Completed
                  </span>
                </Col>
                <Col md={3}>
                  <div className="middleDiv">
                    <img
                      src={CalendarIcon}
                      alt="messageIcon"
                      className="messageIcon"
                    />
                    <span className="approved-on">Approved On</span>
                    <span className="unreadNumberdate">
                      {props.percentageData?.statusChangedDate}
                    </span>
                  </div>
                </Col>
                <Col className="textunderline" md={3}>
                  {/* <a onClick={DownloadFile}>Account Opening check list</a> */}
                  <br />
                  <br />
                  <p className="summaryfindings">
                        <a onClick={()=>window.open(`/complianceView/getSummaryReport/${props.clientId}/${props.clientProductId}`)}>
                        Summary Findings Report</a>
                      </p>
                </Col>
              </Row>
            )}
            {props.percentageData?.status === "REVIEW_DECLINED" && (
              <Row>
                <Col className="overallDiv">
                  <div
                    style={{ width: 105, height: 105 }}
                    className="overallPercentage"
                  >
                    <CircularProgressbar
                      strokeWidth={14}
                      value={
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }
                      text={`${
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }%`}
                      styles={buildStyles({
                        // Rotation of path and trail, in number of turns (0-1)
                        // rotation: 0.25,

                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                        // strokeLinecap: "butt",

                        // Text size
                        textSize: "24px",

                        // How long animation takes to go from one percentage to another, in seconds
                        pathTransitionDuration: 2.0,

                        // Can specify path transition in more detail, or remove it entirely
                        // pathTransition: 'none',

                        // Colors
                        pathColor: `rgba(0,0,0,0.2, ${
                          props.percentageData?.overallPercentage / 100
                        })`,
                        textColor: "#0C2240",
                        trailColor: "rgb(235 235 235)",
                        backgroundColor: "#0C2240",
                      })}
                    />
                  </div>
                  <span className="competionText">
                    Review <br /> Completed
                  </span>
                </Col>
                <Col>
                  <div className="middleDiv">
                    <img
                      src={DeclinedCalendarIcon}
                      alt="messageIcon"
                      className="messageIcon"
                    />
                    <span className="approved-on declinedon">Declined On</span>

                    <span className="unreadNumberdate">
                      {props.percentageData?.statusChangedDate}
                    </span>
                  </div>
                </Col>
                <Col className="declinedContainer">
                  <h1 className="declined">DECLINED</h1>
                </Col>
              </Row>
            )}
          </CardBody>}
          {screenType?.toLowerCase()===CLIENT_SCREEN_TYPES.CLIENT_VIEW && <CardBody className="p-0">
            
              <Row>
                <Col className="overallDiv justify-content-center">
                  <div
                    style={{ width: 105, height: 105 }}
                    className="overallPercentage"
                  >
                    <CircularProgressbar
                      strokeWidth={14}
                      value={
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }
                      text={`${
                        props.percentageData?.overallPercentage === undefined
                          ? 0
                          : props.percentageData?.overallPercentage
                      }%`}
                      styles={buildStyles({
                        textSize: "24px",

                        pathTransitionDuration: 2.0,

                        pathColor: `rgba(0,0,0,0.2, ${
                          props.percentageData?.overallPercentage / 100
                        })`,

                        textColor: "#0C2240",

                        trailColor: "rgb(235 235 235)",

                        backgroundColor: "#0C2240",
                      })}
                    />
                  </div>

                  <span className="competionText OverallCompletion">
                    Overall <br /> Completion
                  </span>
                </Col>

             
              </Row>
            
          </CardBody>}
        </Card>
      </Col>
      <Col>{getDocuSignStatusDetails()}</Col>

      <div className="fileViewerModalContainer">
        <Modal
          className=" mw-100 w-50 p-4 fileViewerModalWrapper"
          isOpen={viewFile}
          fade={false}
          toggle={() => setViewFile((prev) => !prev)}
        >
          <ModalHeader toggle={() => setViewFile((prev) => !prev)}>
            <Row className="customHeader modal-title">
              <Col>
                <div className="fileHeader">{downloadFile?.name}</div>
              </Col>
            </Row>
            <Row></Row>
          </ModalHeader>
          <ModalBody>
            <div className="TC_fileView">
              {downloadFile ? (
                <FileViewer
                  fileType={downloadFile?.fileType}
                  filePath={`data:application/${downloadFile?.fileType};base64,${downloadFile?.image}`}
                />
              ) : (
                ""
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
      {loader ? <FinSpinner /> : ""}
    </Row>
  );
};

export default DashboardStatsFC;
